import React from 'react';

export default function ImpressumContent() {
  return (
    <div className="impressum-content">
      <p>
        Ein Angebot der
        <br />
        SCHICKLER Unternehmensberatung GmbH
        <br />
        <br />
        Alter Wall 22 | 20457 Hamburg
        <br />
        Tel: +49 (0) 40 - 37 66 50-0
        <br />
        info@schickler.de | www.schickler.de
        <br />
        <br />
        Vertreten durch: Alexander Kahlmann, Hendrik Langen, Dr. Christoph Mayer, Patric Tongbhoyai
        <br />
        Sitz: Hamburg | Amtsgericht: Hamburg HRB 72960
        <br />
        Umsatzsteuer-ID: DE202664730
        <br />
        <br />
        Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV: Alexander Kahlmann
        <br />
        <br />
        und
        <br />
        <br />
        dpa Deutsche Presse-Agentur GmbH
        <br />
        <br />
        Mittelweg 38 | 20148 Hamburg
        <br />
        Tel: +49 (0) 40 - 4113-0
        <br />
        info@dpa.com | www.dpa.com
        <br />
        <br />
        Vertreten durch: Peter Kropsch (Vors.), Andreas Schmidt
        <br />
        Sitz: Hamburg | Amtsgericht: Hamburg HRB 68431
        <br />
        Umsatzsteuer-ID: DE 118543436
      </p>
    </div>
  );
}
